var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import scratchblocks from "scratchblocks";
var ScratchBlocks = function (_a) {
    var blockStyle = _a.blockStyle, languages = _a.languages, children = _a.children, props = __rest(_a, ["blockStyle", "languages", "children"]);
    var ref = React.useRef(null);
    React.useEffect(function () {
        var options = {};
        if (blockStyle !== undefined)
            options.style = blockStyle;
        if (languages !== undefined)
            options.languages = languages;
        var doc = scratchblocks.parse(children, options);
        var svg = scratchblocks.render(doc, options);
        ref.current.innerHTML = "";
        ref.current.appendChild(svg);
    }, [blockStyle, languages, children]);
    return React.createElement("div", __assign({ ref: ref }, props));
};
export default ScratchBlocks;
//# sourceMappingURL=index.js.map